export const REQUEST_METRIC_DATA = "request_metric_data"
export const METRIC_DATA_SUCCESS = "metric_data_success"
export const METRIC_DATA_FAILURE = "request_metric_failure"
export const METRIC_ACTION_CHANGES = "metric_action_changes"

export const CLEAR_METRICS = "clear_metrics"